export const FirebaseConfig = {
	"projectId": "corridas-39ba2",
	"appId": "1:283702797519:web:ce4d0b4497dae62f2943ba",
	"databaseURL": "https://corridas-39ba2-default-rtdb.firebaseio.com",
	"storageBucket": "corridas-39ba2.firebasestorage.app",
	"apiKey": "AIzaSyDml6oLaeNtGGCFYQV0bO3I52ndViIs5B8",
	"authDomain": "corridas-39ba2.firebaseapp.com",
	"messagingSenderId": "283702797519",
	"measurementId": "G-3E3BN7M47M",
	"projectNumber": "283702797519",
	"version": "2"
};